import * as yup from 'yup';
import 'yup-phone';

export type InformationInputs = {
  name: string;
  email: string;
  mobile_phone: string;
  photo_id: number | null;
};

export type PasswordInputs = {
  old_password: string;
  password: string;
  password_confirmation: string;
};

export const informationSchema = yup.object().shape({
  name: yup.string().required(),
  email: yup.string().email().label('email'),
  mobile_phone: yup.string().phone('ID', true).required().label('phone number'),
  photo_id: yup.mixed()
});

export const passwordSchema = yup.object().shape({
  old_password: yup.string().min(8).required().label('current password'),
  password: yup.string().min(8).required().label('new password'),
  password_confirmation: yup
    .string()
    .oneOf([yup.ref('password'), null])
    .required()
    .label('confirm new password')
});

export const InformationBaseModel: InformationInputs = {
  name: '',
  email: '',
  mobile_phone: '',
  photo_id: null
};
